var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoundOn24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1c-.642 0-1.258-.25-1.72-.695L7.79 15H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2.765l5.514-5.307A2.481 2.481 0 0 1 15 3Zm5.384 3.343a.9.9 0 0 1 1.273 0 8 8 0 0 1 0 11.314.9.9 0 0 1-1.273-1.273 6.2 6.2 0 0 0 0-8.768.9.9 0 0 1 0-1.273ZM17.838 8.89a.9.9 0 0 1 1.273 0 4.4 4.4 0 0 1 0 6.222.9.9 0 0 1-1.273-1.273 2.6 2.6 0 0 0 0-3.676.9.9 0 0 1 0-1.273Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOn24);
export default __webpack_public_path__ + "static/media/sound_on_24.3670bf72.svg";
export { ForwardRef as ReactComponent };